import script from "./device-card-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-card-info.vue?vue&type=script&lang=ts&setup=true"

import "./device-card-info.vue?vue&type=style&index=0&id=b9ff7bb0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9ff7bb0"]])

export default __exports__